<template>
  <div id="percentageChart">
    <PieChart :chartData="revenueChart" :title="'2019 Revenue by Source'"/>
    <p style="color:white;">While some program areas, e.g. demolition, will never be sustainable absent of grant funding, we continually seek to improve the profitability of our rehab program so that we can maintain our community service into the future.</p>
    <PieChart :chartData="expenseData" :title="'2019 Functional Expenses'"/>
  </div>
</template>
<script>
import PieChart from './PieChart'
export default {
  data() {
    return {
      revenueChart: {
        labels: ['Grants (80%)', 'Property Sales (17%)', 'Other (3%)'],
        datasets: [
          {
            label: '$',
            backgroundColor: ['hsl(163, 40%, 70%)', 'hsl(207, 47%, 65%)', '#eee'],
            data: [849097, 183820, 32251]
          }
        ]
      },
      expenseData: {
        labels: ['Program Expenses (7%)', 'Salaries & Benefits (15%)', 'Demolition (43%)', 'Rehabs (20%)', 'N4N (15%)'],
        datasets: [
          {
            label: '$',
            backgroundColor: ['hsl(163, 40%, 70%)', 'hsl(207, 47%, 65%)', 'hsl(11, 71%, 60%)', 'hsl(39, 100%, 70%)', 'hsl(23, 81%, 60%)', 'hsl(274, 36%, 70%)', '#333', '#eee'],
            data: [74935, 174160, 500873, 230352, 177333]
          }
        ]
      }
    }
  },
  components: { PieChart }
}
</script>



// WEBPACK FOOTER //
// src/components/FinancialsPie.vue